import { LoaderActions } from '@store/loaders'
import { AuthActions } from '@store/reducers/auth'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'

export function* remove() {
  yield put(LoaderActions.set('account_delete'))
  try {
    yield call(NestClient.account.remove)
    yield put(AuthActions.logout())
  } catch (e) {
    console.error('Cannot delete account', e)
    yield put(GeneralErrorNotification)
  } finally {
    yield put(LoaderActions.unset('account_delete'))
  }
}
